module.exports = __webpack_public_path__ + "static/img/13.f53a722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/13.png
// module id = 2AvV
// module chunks = 2